'use client'

import React, { useState } from 'react'
import clsx from 'clsx'
import { MovieData } from '@/types/movie'
import Modal from '@/components/Shared/Modal'
import ModalContainer from '@/components/Shared/Modal/ModalContainer'
import Loading from '@/components/Shared/Loading'
import styles from './styles.module.scss'

interface MovieCardProps {
  movie: MovieData
  used?: string
}

export default function MovieCard({ movie, used }: MovieCardProps) {
  const [modal, setModal] = useState(false)

  const handleClick = () => {
    setModal(true)
  }

  const modalClose = () => {
    setModal(false)
  }

  return (
    <>
      <div
        className={clsx(styles.movie, styles.cardContentsContainer, {
          [styles[used!]]: used,
        })}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      >
        <div className={styles.cardMediaTop}>
          <div className={styles.cardImg}>
            <div className={styles.dummyImageArea} />
            <img
              src={movie.thumbnail || movie.thumbnailUrl || '/images/nothumbnail.webp'}
              width={344}
              height={193.5}
              alt={movie.title}
              className={styles.eyecatchImage}
              loading='lazy'
            />
          </div>
        </div>
        <div className={styles.cardContents}>
          <h2 className={styles.cardTitle}>{movie.title}</h2>
          <p className={styles.cardIntro}>{movie.description}</p>
        </div>
      </div>

      {/* Movie Modal */}
      {modal && (
        <ModalContainer isOpen={modal} onClose={modalClose}>
          <Modal onClose={modalClose} className='movieCard'>
            <figure className={styles.modalMovie}>
              <div className={styles.movieWrapper}>
                <Loading />
                {movie.iframeUrl && movie.iframeUrl !== '' ? (
                  <iframe
                    src={movie.iframeUrl}
                    allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen'
                    width='640'
                    className={styles.movieIframe}
                    allowFullScreen
                  />
                ) : null}
              </div>
              <figcaption className={styles.movieText}>
                <p className={styles.movieTitle}>{movie.title}</p>
                <span className={styles.movieDescription}>{movie.description}</span>
              </figcaption>
            </figure>
          </Modal>
        </ModalContainer>
      )}
    </>
  )
}
